<app-header-content-footer *transloco="let t"
  [headerTitle]="t('coupons')">
  <app-sidenav-content content>
    <app-coupons-list content></app-coupons-list>
  </app-sidenav-content>
</app-header-content-footer> 
